/* eslint-disable */
import React, { Fragment } from 'react'
import Logo from '../../components/Logo'

export default ({children}) => (
	<div className="loading-page">
		<header>
			<div className="content-wrap">
				<Logo />
			</div>
		</header>
		<div className="stat-container">
			<div className="content-wrap">
				<img src="https://www.datocms-assets.com/3323/1528916192-unified-box.png" alt="" className="loader" />
				<p>analyzing...</p>
				{children}
			</div>
		</div>
	</div>
)


// WEBPACK FOOTER //
// ./src/containers/ReportLoader/loaderWrapper.js